export default __webpack_public_path__ + "static/coldwellbanker-88b439f5f6381559b7cf30122462924b.png";